import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard-stat-pills"
}
const _hoisted_2 = { class: "dashboard-stat-pills__label" }
const _hoisted_3 = {
  key: 1,
  class: "dashboard-stat-pills__value"
}

import Skeleton from 'primevue/skeleton';
import { RouterLink } from 'vue-router';
import type { StatPill } from '@/types/StatGroup.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStatPills',
  props: {
    pills: {},
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.pills.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pills, (pill) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(pill.to ? _unref(RouterLink) : 'div'), {
            key: pill.label,
            class: _normalizeClass(["dashboard-stat-pills__pill", { 'dashboard-stat-pills__pill--clickable': !!pill.to }]),
            to: pill.to ?? undefined
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(pill.label), 1),
              (__props.loading)
                ? (_openBlock(), _createBlock(_unref(Skeleton), {
                    key: 0,
                    width: "32px",
                    height: "17px",
                    "border-radius": "4px"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(pill.value), 1))
            ]),
            _: 2
          }, 1032, ["class", "to"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})